import { render, staticRenderFns } from "./ItemSpec.vue?vue&type=template&id=69ee67b0&scoped=true&"
import script from "./ItemSpec.vue?vue&type=script&lang=js&"
export * from "./ItemSpec.vue?vue&type=script&lang=js&"
import style0 from "./ItemSpec.vue?vue&type=style&index=0&id=69ee67b0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ee67b0",
  null
  
)

export default component.exports